import { useSelector } from 'react-redux';
import { selectReportTitle } from '../../selectors';

export const useReportTitle = (): string => {
  const reportTitle = useSelector(selectReportTitle);

  return reportTitle;
};
